import React from 'react'

function Data({covidData,flag}) {
    return (
        <>
                <div className="text-light bg-secondary mb-3 w-100 d-flex align-items-center justify-content-center">
                    <h1>{covidData[0].country}</h1>
                    <img className="ms-2" src={`https://www.countryflags.io/${flag}/flat/64.png`} alt="" />
                </div>
                <div className="row">

                    <div className="col-xl-4 col-sm-10 col-md-6">
                        <div className="card text-dark bg-light mb-3">
                            <div className="card-header bg-dark text-light fs-4">Total cases</div>
                            <div className="card-body">
                                <h1 className="card-title text-center">{covidData[0].cases.toLocaleString()}</h1>
                                
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-4 col-sm-10 col-md-6">
                        <div className="card text-dark bg-light mb-3">
                            <div className="card-header bg-dark text-light fs-4">Recovered</div>
                            <div className="card-body">
                                <h1 className="card-title text-center">{covidData[0].recovered.toLocaleString()}</h1>
                                
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-4 col-sm-10 col-md-6">
                        <div className="card text-dark bg-light mb-3">
                            <div className="card-header bg-dark text-light fs-4">Active</div>
                            <div className="card-body">
                                <h1 className="card-title text-center">{covidData[0].active.toLocaleString()}</h1>
                                
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-4 col-sm-10 col-md-6">
                        <div className="card text-dark bg-light mb-3">
                            <div className="card-header bg-dark text-light fs-4">Total Deaths</div>
                            <div className="card-body">
                                <h1 className="card-title text-center">{covidData[0].deaths.toLocaleString()}</h1>
                                
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-4 col-sm-10 col-md-6">
                        <div className="card text-dark bg-light mb-3">
                            <div className="card-header bg-dark text-light fs-4">Today cases</div>
                            <div className="card-body">
                                <h1 className="card-title text-center">{covidData[0].todayCases.toLocaleString()}</h1>
                                
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-4 col-sm-10 col-md-6">
                        <div className="card text-dark bg-light mb-3">
                            <div className="card-header bg-dark text-light fs-4">Today Deaths</div>
                            <div className="card-body">
                                <h1 className="card-title text-center">{covidData[0].todayDeaths.toLocaleString()}</h1>
                                
                            </div>
                        </div>
                    </div>
                </div> 
        </>
    )
}

export default Data
